import { REVIEW_STATES, SUBJECT_OPTIONS } from './consts';

// const template = {
//   arxivID: '',
//   title: '',
//   submitDate: '2022-02-07T23:21:11.198Z',
//   reviewDate: '2022-03-17T23:21:11.198Z',
//   authors: [],
//   subjects: [SUBJECT_OPTIONS.GANS],
//   abstract: '',
//   reviewState: REVIEW_STATES.PRE_REVIEW.name,
//   doubleBlind: true,
//   hasCode: false,
//   // mockBadges: [{ icon: 'ant-design:trophy-outline', label: 'Top %5 March 2021' }],
// };

const elad = {
  arxivID: '04242.1818v4',
  title: 'E-LAD - Simulating Electronic Chatbots using GPT-5',
  submitDate: '2022-05-07T23:21:11.198Z',
  reviewDate: '2022-05-20T23:21:11.198Z',
  authors: ['Adam', 'Ano Nymus'],
  subjects: [SUBJECT_OPTIONS.DOCUMENT],
  abstract:
    'Language models have shown major improvement in recent years. However, the improvement is limited by the fact that they are not trained on the same corpus. ' +
    'In this paper, we propose a new approach to language modeling that is based on the idea of “language-agnostic dialogue systems” (LAD) and is trained on the corpus of human-human conversations. ' +
    'We show that LAD can be used to simulate human-human conversations using GPT-5. ' +
    'We also show that LAD can be used to simulate human-bot conversations using GPT-2.',
  reviewState: REVIEW_STATES.AUTHOR_RESPONSE.name,
  stateUpdateTime: '2022-05-15T23:21:11.198Z',
  doubleBlind: true,
  hasCode: false,
  // mockBadges: [{ icon: 'ant-design:trophy-outline', label: 'Top %5 March 2021' }],
  reviews: [
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla No Novel!', initialScore: 4, finalScore: 4 },
      validation: { text: 'Much Validation!', initialScore: 2, finalScore: 3 },
      significance: { text: 'No Significant!', initialScore: 2, finalScore: 2 },
      presentation: { text: 'WOW! Much Pres!', initialScore: 4, finalScore: 5 },
      reproducibility: { text: 'Just did!', initialScore: 1, finalScore: 1 },
    },
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      validation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      significance: { text: 'Bla Bla', initialScore: 2, finalScore: 2 },
      presentation: { text: 'Bla Bla', initialScore: 4, finalScore: 4 },
      reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
    },
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla', initialScore: 4, finalScore: 5 },
      validation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      significance: { text: 'Bla Bla', initialScore: 1, finalScore: 2 },
      presentation: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
      reproducibility: { text: 'Bla Bla', initialScore: 2, finalScore: 1 },
    },
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla', initialScore: 5, finalScore: 4 },
      validation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      significance: { text: 'Bla Bla', initialScore: 2, finalScore: 3 },
      presentation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 2 },
    },
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla', initialScore: 3, finalScore: 5 },
      validation: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
      significance: { text: 'Bla Bla', initialScore: 3, finalScore: 5 },
      presentation: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
      reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 5 },
    },
  ],
  discussion: [
    { reviewer: 1, time: '2022-03-17T23:21:11.198Z', text: 'I think we should consider' },
    { reviewer: 3, time: '2022-03-17T23:24:11.198Z', text: 'Agreed!' },
  ],
};

const nofar = {
  arxivID: '1707.010711v2',
  title: 'NO-FAR - A Fast Approximation of Point Distance on a Manifold',
  submitDate: '2022-02-07T23:21:11.198Z',
  reviewDate: '2022-03-17T23:21:11.198Z',
  authors: ['Et Al'],
  subjects: [SUBJECT_OPTIONS.FEW_SHOT],
  abstract:
    'The problem id distance estimation on a manifold has troubled mankind for many decades. ' +
    'We put an end to this problem by introducing a new distance estimation algorithm called NO-FAR. ' +
    'Unlike previous approaches which are slow, NO-FAR is just fast. ' +
    'Why? Because of a novel approximation mechanism that significantly improve the runtime. ' +
    'We hope that our method will have a positive impact on the community. ' +
    'We specifically show that this distance estimation is useful for few-shot learning. ',
  reviewState: REVIEW_STATES.PRE_REVIEW.name,
  doubleBlind: true,
  hasCode: false,
  // mockBadges: [{ icon: 'ant-design:trophy-outline', label: 'Top %5 March 2021' }],
};

const yuval = {
  arxivID: '812.14122v1',
  title: 'YU-VAL: Using the YU Metric for improved Validation of Classification Models',
  submitDate: '2022-02-07T23:21:11.198Z',
  reviewDate: '2022-03-17T23:21:11.198Z',
  authors: ['Et Al'],
  subjects: [SUBJECT_OPTIONS.DET],
  abstract:
    'The YU metric has recently reemerged in the field of machine learning as a promising alternative to the AUC metric. However, the YU metric is not suitable for validation of classification models, since it is not a good metric for the classification task. In this paper, we propose a new metric, YU-VAL, that is suitable for validation of classification models. The YU-VAL metric is based on the YU metric, but it is designed to be used for validation of classification models. The YU-VAL metric is a generalization of the YU metric, which is a generalization of the AUC metric. The YU-VAL metric is a good metric for validation of classification models, since it is a good metric for the classification task. We show that the YU-VAL metric is a good metric for validation of classification models. We also show that the YU-VAL metric is a good metric for the classification task.',
  reviewState: REVIEW_STATES.PRE_REVIEW.name,
  doubleBlind: true,
  hasCode: false,
  // mockBadges: [{ icon: 'ant-design:trophy-outline', label: 'Top %5 March 2021' }],
};

const kfir = {
  arxivID: '8214.11114v4',
  title: 'K-FIR: K-Farthest Point Image Retrieval',
  submitDate: '2022-02-07T23:21:11.198Z',
  reviewDate: '2022-03-17T23:21:11.198Z',
  authors: ['adam'],
  subjects: [SUBJECT_OPTIONS.DET],
  abstract:
    'Usually when we solve the task of image retrieval we try to find the K-Nearest Neighbours of a given sample. ' +
    'In this paper we ask ourselves, what if instead of finding the K-Nearest Neighbours we want to find the K-Farthest Neighbours? ' +
    'How far can we get? Turns out that as K grows we must choose points that are getting closer to the original sample. ' +
    'We therefore deduce that K-NN and K-FIR operates the same when K reaches the size of the dataset.',
  reviewState: REVIEW_STATES.DISCUSSION.name,
  doubleBlind: true,
  hasCode: false,
  // mockBadges: [{ icon: 'ant-design:trophy-outline', label: 'Top %5 March 2021' }],
  reviews: [
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla No Novel!', initialScore: 4, finalScore: 4 },
      validation: { text: 'Much Validation!', initialScore: 2, finalScore: 3 },
      significance: { text: 'No Significant!', initialScore: 2, finalScore: 2 },
      presentation: { text: 'WOW! Much Pres!', initialScore: 4, finalScore: 5 },
      reproducibility: { text: 'Just did!', initialScore: 1, finalScore: 1 },
    },
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      validation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      significance: { text: 'Bla Bla', initialScore: 2, finalScore: 2 },
      presentation: { text: 'Bla Bla', initialScore: 4, finalScore: 4 },
      reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
    },
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla', initialScore: 4, finalScore: 5 },
      validation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      significance: { text: 'Bla Bla', initialScore: 1, finalScore: 2 },
      presentation: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
      reproducibility: { text: 'Bla Bla', initialScore: 2, finalScore: 1 },
    },
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla', initialScore: 5, finalScore: 4 },
      validation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      significance: { text: 'Bla Bla', initialScore: 2, finalScore: 3 },
      presentation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 2 },
    },
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla', initialScore: 3, finalScore: 5 },
      validation: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
      significance: { text: 'Bla Bla', initialScore: 3, finalScore: 5 },
      presentation: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
      reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 5 },
    },
  ],
  discussion: [
    {
      reviewer: 1,
      time: '2022-03-17T23:21:11.198Z',
      text: 'I think we should consider raising the novelty score, as some aspects of this work are really novel.',
    },
    { reviewer: 3, time: '2022-03-17T23:24:11.198Z', text: 'Agreed!' },
  ],
};

const connecting = {
  arxivID: '61421.0001',
  title: 'Connecting the Dots: Fast Dot Product using Connected Components',
  submitDate: '2022-02-07T23:21:11.198Z',
  reviewDate: '2022-03-20T23:21:11.198Z',
  authors: ['Et Al'],
  subjects: [SUBJECT_OPTIONS.ARCHITECTURES],
  abstract:
    'Dot product is the core operation in neural networks. However, it is often slow and inefficient. We propose a fast dot product algorithm that uses a graph representation of the computation graph to compute the dot product of two tensors. We show that the algorithm is much faster than the naive implementation and achieves comparable performance to the standard dot product. We also show that the algorithm can be used to compute the dot product of a large number of tensors.',
  reviewState: REVIEW_STATES.AUTHOR_RESPONSE.name,
  stateUpdateTime: '2022-05-16T10:21:11.198Z',
  doubleBlind: true,
  hasCode: false,
  reviews: [
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla No Novel!', initialScore: 4, finalScore: 4 },
      validation: { text: 'Much Validation!', initialScore: 2, finalScore: 3 },
      significance: { text: 'No Significant!', initialScore: 2, finalScore: 2 },
      presentation: { text: 'WOW! Much Pres!', initialScore: 4, finalScore: 5 },
      reproducibility: { text: 'Just did!', initialScore: 1, finalScore: 1 },
    },
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      validation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      significance: { text: 'Bla Bla', initialScore: 2, finalScore: 2 },
      presentation: { text: 'Bla Bla', initialScore: 4, finalScore: 4 },
      reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
    },
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla', initialScore: 4, finalScore: 5 },
      validation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      significance: { text: 'Bla Bla', initialScore: 1, finalScore: 2 },
      presentation: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
      reproducibility: { text: 'Bla Bla', initialScore: 2, finalScore: 1 },
    },
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla', initialScore: 5, finalScore: 4 },
      validation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      significance: { text: 'Bla Bla', initialScore: 2, finalScore: 3 },
      presentation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 2 },
    },
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla', initialScore: 3, finalScore: 5 },
      validation: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
      significance: { text: 'Bla Bla', initialScore: 3, finalScore: 5 },
      presentation: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
      reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 5 },
    },
  ],
  discussion: [
    { reviewer: 1, time: '2022-03-17T23:21:11.198Z', text: 'I think we should consider' },
    { reviewer: 3, time: '2022-03-17T23:24:11.198Z', text: 'Agreed!' },
  ],
  // mockBadges: [{ icon: 'ant-design:trophy-outline', label: 'Top %5 March 2021' }],
};

const nerfoundation = {
  arxivID: '991221.0179v3',
  title: 'NerFoundation: Scaling Neural Radiance Fields to Globe Scale',
  submitDate: '2022-02-07T23:21:11.198Z',
  reviewDate: '2022-03-17T23:21:11.198Z',
  authors: ['Et Al', 'Ano Nymus'],
  subjects: [SUBJECT_OPTIONS.DDD],
  abstract:
    'NerFs are cool, but current models are just not scalable. This limits their applications to specific rooms and requires a new model for each new scene.' +
    'This paper proposes a new model that can be scaled to any room size. The model is trained on a large dataset of scenes from the real world. ' +
    'Learning from so much data our NerFoundation learns to generate entire countries and we also show that it can be extend to an entire globe.' +
    'In future works we hope to show that with only 100B parameters are model can render entire galaxies.  ',
  reviewState: REVIEW_STATES.FIRST_ROUND.name,
  doubleBlind: true,
  hasCode: false,
  // mockBadges: [{ icon: 'ant-design:trophy-outline', label: 'Top %5 March 2021' }],
};

const details = {
  arxivID: '1211.55555',
  title: 'Attention (to details) is All You Need',
  submitDate: '2021-01-07T23:21:11.198Z',
  reviewDate: '2021-03-14T23:21:11.198Z',
  authors: ['Et Al'],
  subjects: [SUBJECT_OPTIONS.ARCHITECTURES, SUBJECT_OPTIONS.GANS],
  abstract:
    'It is a common misconception that training Neural Networks requires a single trick that will solve all of your problems.' +
    'Unfortunately, this is not the case. In practice there are many different tricks that need to be applied to train a successful neural network. ' +
    'We conduct a psychological study where we take different ML practitioners and check their attention to details. ' +
    'Our study cleary shows that people with attention to details have a greater chance at training a powerful neural network. Evaluation on GANs shows that this is true for GANs as well.',
  reviewState: REVIEW_STATES.POST_REVIEW.name,
  doubleBlind: true,
  hasCode: false,
  mockBadges: [
    { icon: 'ant-design:trophy-outline', label: 'Top %5 March 2021' },
    { icon: 'ant-design:trophy-outline', label: 'Top %10 2021' },
  ],
  reviews: [
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla No Novel!', initialScore: 2, finalScore: 1 },
      validation: { text: 'Much Validation!', initialScore: 4, finalScore: 5 },
      significance: { text: 'No Significant!', initialScore: 3, finalScore: 4 },
      presentation: { text: 'WOW! Much Pres!', initialScore: 4, finalScore: 5 },
      reproducibility: { text: 'Just did!', initialScore: 5, finalScore: 5 },
    },
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla', initialScore: 5, finalScore: 2 },
      validation: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
      significance: { text: 'Bla Bla', initialScore: 2, finalScore: 5 },
      presentation: { text: 'Bla Bla', initialScore: 4, finalScore: 1 },
      reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 2 },
    },
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      validation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      significance: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
      presentation: { text: 'Bla Bla', initialScore: 3, finalScore: 1 },
      reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
    },
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      validation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      significance: { text: 'Bla Bla', initialScore: 3, finalScore: 2 },
      presentation: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
      reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 1 },
    },
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla', initialScore: 3, finalScore: 2 },
      validation: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
      significance: { text: 'Bla Bla', initialScore: 3, finalScore: 5 },
      presentation: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
      reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 5 },
    },
  ],
  authorResponse:
    'We thank the reviewers for their time, You guys are the best! We generally agree with the ratings of the reviewers.' +
    ' As to the significance, we believe that our model is more significant than comparable models and hope that the community will find it useful.',
};
const shallow = {
  arxivID: '81231.1231',
  title: 'Returning to the Shallows: Shallow Networks are better than no Networks',
  submitDate: '2020-02-07T23:21:11.198Z',
  reviewDate: '2020-03-17T23:21:11.198Z',
  authors: ['Et Al'],
  subjects: [SUBJECT_OPTIONS.ARCHITECTURES],
  abstract:
    'In recent years we have seen a clear trend to create deeper and deeper networks, creating the so-called Deep Learning trend.' +
    'However, the deep networks are not always better than the shallow networks. In this paper, we will discuss the differences between the shallow and deep networks.' +
    'While Deep Neural Networks significantly outperform shallow networks, they are not always better than the shallow networks. ' +
    'For example, from the moral perspective, shallow networks use less resources and therefore are better. ' +
    'Furthermore, it has been shown that training shallow networks causes less stress in researchers and is overall a more enjoyable process.',
  reviewState: REVIEW_STATES.POST_REVIEW.name,
  doubleBlind: false,
  hasCode: false,
  mockBadges: [],
  reviews: [
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla No Novel!', initialScore: 2, finalScore: 2 },
      validation: { text: 'Much Validation!', initialScore: 4, finalScore: 3 },
      significance: { text: 'No Significant!', initialScore: 3, finalScore: 4 },
      presentation: { text: 'WOW! Much Pres!', initialScore: 4, finalScore: 4 },
      reproducibility: { text: 'Just did!', initialScore: 5, finalScore: 4 },
    },
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla', initialScore: 5, finalScore: 2 },
      validation: { text: 'Bla Bla', initialScore: 3, finalScore: 2 },
      significance: { text: 'Bla Bla', initialScore: 2, finalScore: 1 },
      presentation: { text: 'Bla Bla', initialScore: 4, finalScore: 2 },
      reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
    },
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla', initialScore: 3, finalScore: 2 },
      validation: { text: 'Bla Bla', initialScore: 3, finalScore: 2 },
      significance: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      presentation: { text: 'Bla Bla', initialScore: 3, finalScore: 5 },
      reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
    },
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla', initialScore: 3, finalScore: 1 },
      validation: { text: 'Bla Bla', initialScore: 3, finalScore: 2 },
      significance: { text: 'Bla Bla', initialScore: 3, finalScore: 2 },
      presentation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
    },
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla', initialScore: 3, finalScore: 2 },
      validation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      significance: { text: 'Bla Bla', initialScore: 3, finalScore: 5 },
      presentation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
    },
  ],
  authorResponse:
    'We thank the reviewers for their time, You guys are the best! We generally agree with the ratings of the reviewers.' +
    ' As to the significance, we believe that our model is more significant than comparable models and hope that the community will find it useful.',
};

const oneshot = {
  arxivID: '88121.0142',
  title: 'One Shot Too Many: Crime Scene Analysis using Anomaly Detection',
  submitDate: '2021-05-07T23:21:11.198Z',
  reviewDate: '2021-07-17T23:21:11.198Z',
  authors: ['Adam', 'FDC Willard'],
  subjects: [SUBJECT_OPTIONS.DET, SUBJECT_OPTIONS.ACTION_RECOGNITION],
  abstract:
    'Anomaly detection is a well known task in Machine Learning. One important application is in the field of crime scene analysis.' +
    'Crime Scenes can be really challenging to analyze, as they are often very large and complex. In this paper, we propose a novel approach to crime scene analysis using anomaly detection.' +
    'Our method is self-supervised and can be used to detect anomalies in a large number of datasets. ' +
    'We believe that our paper is an anomaly in its novelty and significance and we hope that it would have a positive effect on crime reduction.',
  reviewState: REVIEW_STATES.POST_REVIEW.name,
  doubleBlind: false,
  hasCode: false,
  mockBadges: [{ icon: 'ant-design:trophy-outline', label: 'Top %20 July 2021 for Presentation' }],
  reviews: [
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla No Novel!', initialScore: 2, finalScore: 2 },
      validation: { text: 'Much Validation!', initialScore: 4, finalScore: 3 },
      significance: { text: 'No Significant!', initialScore: 3, finalScore: 5 },
      presentation: { text: 'WOW! Much Pres!', initialScore: 4, finalScore: 5 },
      reproducibility: { text: 'Just did!', initialScore: 2, finalScore: 2 },
    },
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla', initialScore: 5, finalScore: 3 },
      validation: { text: 'Bla Bla', initialScore: 3, finalScore: 1 },
      significance: { text: 'Bla Bla', initialScore: 2, finalScore: 2 },
      presentation: { text: 'Bla Bla', initialScore: 4, finalScore: 4 },
      reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 2 },
    },
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla', initialScore: 3, finalScore: 2 },
      validation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      significance: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
      presentation: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
      reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 2 },
    },
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla', initialScore: 3, finalScore: 2 },
      validation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      significance: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      presentation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 2 },
    },
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      validation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      significance: { text: 'Bla Bla', initialScore: 3, finalScore: 2 },
      presentation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 5 },
    },
  ],
  authorResponse: 'We thank the reviewers for their time.',
};

const dolphin = {
  arxivID: '6612.013811',
  title: 'DOLPHIN: Rethinking MAMLs for Multi-Modality Datasets',
  submitDate: '2021-09-07T23:21:11.198Z',
  reviewDate: '2021-10-10T23:21:11.198Z',
  authors: ['Et Al'],
  subjects: [SUBJECT_OPTIONS.ADAPT],
  abstract:
    'MAML is a powerful tool for training deep neural networks. ' +
    'However, it is not robust to the presence of outliers in the training data. ' +
    'In this paper, we propose a novel approach to MAML that is robust to outliers. ' +
    'We show that our approach is able to train deep neural networks on multi-modality datasets with high accuracy and low training time. ' +
    'We hope that the release of DOLPHIN will encourage the development of robust MAMLs. ',
  reviewState: REVIEW_STATES.POST_REVIEW.name,
  doubleBlind: false,
  hasCode: false,
  mockBadges: [{ icon: 'ant-design:trophy-outline', label: 'Top %10 2021 for Novelty' }],
  reviews: [
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla No Novel!', initialScore: 2, finalScore: 5 },
      validation: { text: 'Much Validation!', initialScore: 4, finalScore: 4 },
      significance: { text: 'No Significant!', initialScore: 3, finalScore: 3 },
      presentation: { text: 'WOW! Much Pres!', initialScore: 4, finalScore: 5 },
      reproducibility: { text: 'Just did!', initialScore: 2, finalScore: 2 },
    },
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla', initialScore: 5, finalScore: 4 },
      validation: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
      significance: { text: 'Bla Bla', initialScore: 2, finalScore: 2 },
      presentation: { text: 'Bla Bla', initialScore: 4, finalScore: 4 },
      reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
    },
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      validation: { text: 'Bla Bla', initialScore: 3, finalScore: 1 },
      significance: { text: 'Bla Bla', initialScore: 3, finalScore: 5 },
      presentation: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
      reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 2 },
    },
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      validation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      significance: { text: 'Bla Bla', initialScore: 3, finalScore: 2 },
      presentation: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
      reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 2 },
    },
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla', initialScore: 3, finalScore: 5 },
      validation: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
      significance: { text: 'Bla Bla', initialScore: 3, finalScore: 5 },
      presentation: { text: 'Bla Bla', initialScore: 3, finalScore: 2 },
      reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 5 },
    },
  ],
  authorResponse:
    'We thank the reviewers for their time, You guys are the best! We are very happy with the paper and we are looking forward to its publication.',
};

const blocks = {
  arxivID: '541111.2222',
  title: 'StyleChain: StyleGAN Image Generation as Proof of Work for Blockchains',
  submitDate: '2022-02-07T23:21:11.198Z',
  reviewDate: '2022-03-17T23:21:11.198Z',
  authors: ['Adam', 'Ano Nymus'],
  subjects: [SUBJECT_OPTIONS.GANS, SUBJECT_OPTIONS.IMAGE2IMAGE],
  abstract:
    'In recent years the blockchain has become an important part of our internet life. ' +
    'The blockchain is a distributed ledger that allows for the creation of smart contracts and smart assets. One of the challenges in blockchain is the need for a way to generate images that are cryptographically secure. ' +
    'Here we show that by using Image Generation as a Proof of Work we can solve all our problems. ' +
    'The process is done by using StyleGAN, a generative model that generates images from a single noise vector. ' +
    'Images are first sampled from StyleGAN and a user than verifies that this person does not exist',
  reviewState: REVIEW_STATES.PRE_REVIEW.name,
  doubleBlind: true,
  hasCode: false,
  // mockBadges: [{ icon: 'ant-design:trophy-outline', label: 'Top %5 March 2021' }],
};

const MRI = {
  arxivID: '15151.5142v2',
  title: 'Rethinking Thoughts: Neural Radiance Fields from MRI Scans',
  submitDate: '2022-02-07T23:21:11.198Z',
  reviewDate: '2022-03-17T23:21:11.198Z',
  authors: ['Ano Nymus'],
  subjects: [SUBJECT_OPTIONS.GANS],
  abstract:
    'Neural Radiance Fields have been shown to be a strong representation of 3D Structures. ' +
    'We know that the human brain is composed of many different structures and is able to map complex 3D patterns. ' +
    'However, we have not yet been able to map the brain from MRI scans. We propose a novel approach to map brain MRI to the 3D structures that a user is thinking about' +
    'This is the first glimse we have of a novel approach to map brain MRI to the 3D structures that a user is thinking about.' +
    'Experiments show that our approach is working and that indeed we can map brain MRI to the 3D structures that a user is thinking about.',
  reviewState: REVIEW_STATES.PRE_REVIEW.name,
  doubleBlind: true,
  hasCode: false,
  // mockBadges: [{ icon: 'ant-design:trophy-outline', label: 'Top %5 March 2021' }],
};

const leshrod = {
  arxivID: '52345.1234',
  title: 'LeSchrodinger: A proposal for a Quantum Neural Network',
  submitDate: '2022-02-07T23:21:11.198Z',
  authors: ['FDC Willard', 'Ano Nymus'],
  subjects: [SUBJECT_OPTIONS.FEW_SHOT, SUBJECT_OPTIONS.ADAPT],
  abstract:
    'Quantum Neural Network is an emerging research field.' +
    ' Here we survey the state of the art in this field and propose our own brand new neural network that is based on quantum mechanics. ' +
    'We will show that our proposed neural network is capable of learning complex functions and that it can be used to solve many different problems.' +
    'As a result, we will be able to solve many different problems with our proposed neural network.' +
    ' Please do not measure the performance of our proposed network to avoid collapsing the results of the experiments.',
  reviewState: REVIEW_STATES.FIRST_ROUND.name,
  doubleBlind: true,
  hasCode: false,
  // mockBadges: [{ icon: 'ant-design:trophy-outline', label: 'Top %5 March 2021' }],
};

const fastest = {
  arxivID: '10234.5678',
  title: 'Fastest R-CNN: Faster than Real Time Object Detection',
  submitDate: '2022-02-07T23:21:11.198Z',
  reviewDate: '2022-03-10T23:21:11.198Z',
  authors: ['FDC Willard', 'Ano Nymus'],
  subjects: [SUBJECT_OPTIONS.DET, SUBJECT_OPTIONS.ARCHITECTURES],
  abstract:
    'We present a novel R-CNN architecture that achieves faster inference speed than any other R-CNN model on ImageNet.' +
    'Our architecture builds upon ideas from Faster R-CNN, but uses a different backbone architecture and a novel loss function. ' +
    'Our experiments show that we are indeed faster than Faster R-CNN on ImageNet. ' +
    'Theoretical hand-waving show that no further improvements are possible, making our R-CNN the fastest. Code will be published upon acceptance and will be available on GitHub.',
  reviewState: REVIEW_STATES.POST_REVIEW.name,
  doubleBlind: true,
  hasCode: false,
  mockBadges: [
    { icon: 'ant-design:trophy-outline', label: 'Top %5 March 2021' },
    { icon: 'ant-design:trophy-outline', label: 'Top %10 2021' },
  ],
  reviews: [
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla No Novel!', initialScore: 2, finalScore: 2 },
      validation: { text: 'Much Validation!', initialScore: 4, finalScore: 4 },
      significance: { text: 'No Significant!', initialScore: 3, finalScore: 5 },
      presentation: { text: 'WOW! Much Pres!', initialScore: 4, finalScore: 5 },
      reproducibility: { text: 'Just did!', initialScore: 5, finalScore: 5 },
    },
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla', initialScore: 5, finalScore: 3 },
      validation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      significance: { text: 'Bla Bla', initialScore: 2, finalScore: 2 },
      presentation: { text: 'Bla Bla', initialScore: 4, finalScore: 4 },
      reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
    },
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      validation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      significance: { text: 'Bla Bla', initialScore: 3, finalScore: 5 },
      presentation: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
      reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
    },
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      validation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      significance: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      presentation: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
      reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
    },
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla', initialScore: 3, finalScore: 2 },
      validation: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
      significance: { text: 'Bla Bla', initialScore: 3, finalScore: 5 },
      presentation: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
      reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 5 },
    },
  ],
  authorResponse:
    'We thank the reviewers for their time, You guys are the best! We generally agree with the ratings of the reviewers.' +
    ' As to the significance, we believe that our model is more significant than comparable models and hope that the community will find it useful.',
};

export const psp = {
  arxivID: '8009.00981v1',
  title: 'Rethinking is All You Need!',
  submitDate: '2022-02-07T23:21:11.198Z',
  reviewDate: '2022-03-17T23:21:11.198Z',
  authors: ['Alec Newton', 'Yann Hinton', 'Et Al'],
  figureLink: 'https://d3i71xaburhd42.cloudfront.net/a8951ef48dc71f6a1778bbed964f09480fcc3f4c/1-Figure1-1.png',
  subjects: [SUBJECT_OPTIONS.GANS, SUBJECT_OPTIONS.IMAGE2IMAGE],
  abstract:
    'We present a generic image-to-image translation framework, pixel2style2pixel (pSp). Our pSp framework is based on a novel encoder network that directly generates a series of style vectors which are fed into a pretrained StyleGAN generator, forming the extended W+ latent space. We first show that our encoder can directly embed real images into W+, with no additional optimization. Next, we propose utilizing our encoder to directly solve image-to-image translation tasks, defining them as encoding problems from some input domain into the latent domain. By deviating from the standard invert first, edit later methodology used with previous StyleGAN encoders, our approach can handle a variety of tasks even when the input image is not represented in the StyleGAN domain. We show that solving translation tasks through StyleGAN significantly simplifies the training process, as no adversary is required, has better support for solving tasks without pixel-to-pixel correspondence, and inherently supports multi-modal synthesis via the resampling of styles. Finally, we demonstrate the potential of our framework on a variety of facial image-to-image translation tasks, even when compared to state-of-the-art solutions designed specifically for a single task, and further show that it can be extended beyond the human facial domain.',
  reviewState: REVIEW_STATES.POST_REVIEW.name,
  doubleBlind: true,
  hasCode: false,
  mockBadges: [{ icon: 'ant-design:trophy-outline', label: 'Top %5 March 2022' }],
  reviews: [
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla No Novel!', initialScore: 2, finalScore: 2 },
      validation: { text: 'Much Validation!', initialScore: 4, finalScore: 4 },
      significance: { text: 'No Significant!', initialScore: 3, finalScore: 5 },
      presentation: { text: 'WOW! Much Pres!', initialScore: 4, finalScore: 5 },
      reproducibility: { text: 'Just did!', initialScore: 5, finalScore: 5 },
    },
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla', initialScore: 5, finalScore: 3 },
      validation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      significance: { text: 'Bla Bla', initialScore: 2, finalScore: 2 },
      presentation: { text: 'Bla Bla', initialScore: 4, finalScore: 4 },
      reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
    },
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      validation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      significance: { text: 'Bla Bla', initialScore: 3, finalScore: 5 },
      presentation: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
      reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
    },
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      validation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      significance: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      presentation: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
      reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
    },
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
      validation: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
      significance: { text: 'Bla Bla', initialScore: 3, finalScore: 5 },
      presentation: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
      reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 5 },
    },
  ],
  authorResponse: 'I thank the reviewers for their time, You guys are the best!',
  // TODO: Think it review should be a subdictionary, could make sense but dont want to overcomplicate the code,
};

export const paper2 = {
  arxivID: '8019.00781v2',
  title: 'Generative Diffusion Models for Cloud Gazing',
  submitDate: '2021-05-07T23:21:11.198Z',
  reviewDate: '2021-07-17T23:21:11.198Z',
  figureLink: 'https://d3i71xaburhd42.cloudfront.net/64ea8f180d0682e6c18d1eb688afdb2027c02794/1-Figure1-1.png',
  authors: ['Et Al', 'Ano Nymus'],
  subjects: [SUBJECT_OPTIONS.GANS, SUBJECT_OPTIONS.DIFFUSION],
  abstract:
    'We present a generic image-to-image translation framework, pixel2style2pixel (pSp). Our pSp framework is based on a novel encoder network that directly generates a series of style vectors which are fed into a pretrained StyleGAN generator, forming the extended W+ latent space. We first show that our encoder can directly embed real images into W+, with no additional optimization. Next, we propose utilizing our encoder to directly solve image-to-image translation tasks, defining them as encoding problems from some input domain into the latent domain. By deviating from the standard invert first, edit later methodology used with previous StyleGAN encoders, our approach can handle a variety of tasks even when the input image is not represented in the StyleGAN domain. We show that solving translation tasks through StyleGAN significantly simplifies the training process, as no adversary is required, has better support for solving tasks without pixel-to-pixel correspondence, and inherently supports multi-modal synthesis via the resampling of styles. Finally, we demonstrate the potential of our framework on a variety of facial image-to-image translation tasks, even when compared to state-of-the-art solutions designed specifically for a single task, and further show that it can be extended beyond the human facial domain.',
  reviewState: REVIEW_STATES.DISCUSSION.name,
  stateUpdateTime: '2023-07-17T23:21:11.198Z',
  doubleBlind: false,
  hasCode: true,
  mockBadges: [{ icon: 'ant-design:trophy-outline', label: 'Top %1 2018' }],
  reviews: [
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla No Novel!', initialScore: 4, finalScore: 4 },
      validation: { text: 'Much Validation!', initialScore: 2, finalScore: 3 },
      significance: { text: 'No Significant!', initialScore: 2, finalScore: 2 },
      presentation: { text: 'WOW! Much Pres!', initialScore: 4, finalScore: 5 },
      reproducibility: { text: 'Just did!', initialScore: 1, finalScore: 1 },
    },
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      validation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      significance: { text: 'Bla Bla', initialScore: 2, finalScore: 2 },
      presentation: { text: 'Bla Bla', initialScore: 4, finalScore: 4 },
      reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
    },
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla', initialScore: 4, finalScore: 5 },
      validation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      significance: { text: 'Bla Bla', initialScore: 1, finalScore: 2 },
      presentation: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
      reproducibility: { text: 'Bla Bla', initialScore: 2, finalScore: 1 },
    },
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla', initialScore: 5, finalScore: 4 },
      validation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      significance: { text: 'Bla Bla', initialScore: 2, finalScore: 3 },
      presentation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
      reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 2 },
    },
    {
      remarks: {
        paperBrief: 'It has words ',
        updateSummary: 'I realized paper is more novel than I originally thought',
      },
      novelty: { text: 'Bla Bla', initialScore: 3, finalScore: 5 },
      validation: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
      significance: { text: 'Bla Bla', initialScore: 3, finalScore: 5 },
      presentation: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
      reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 5 },
    },
  ],
  discussion: [
    { reviewer: 1, time: '2022-03-17T23:21:11.198Z', text: 'I think we should consider' },
    { reviewer: 3, time: '2022-03-17T23:24:11.198Z', text: 'Agreed!' },
  ],
  authorResponse: 'We thank the reviewers for gazing into the future with us!',
  // TODO: Think it review should be a subdictionary, could make sense but dont want to overcomplicate the code,
};

// const diffusion = {
//   arxivID: '2006.11239v1',
//   title: 'Denoising Diffusion Probabilistic Models',
//   paperLink: 'https://arxiv.org/abs/2008.00951',
//   codeLink: 'https://github.com/eladrich/pixel2style2pixel',
//   pageLink: 'https://eladrich.github.io/pixel2style2pixel/',
//   figureLink: 'https://d3i71xaburhd42.cloudfront.net/5c126ae3421f05768d8edd97ecd44b1364e2c99a/1-Figure1-1.png',
//   submitDate: '2020-01-07T23:21:11.198Z',
//   authors: ['Jonathan Ho', 'Ajay Jain', 'Pieter Abbeel'],
//   subjects: [SUBJECT_OPTIONS.DIFFUSION],
//   field: ['Image Generation', 'Image Editing'],
//   abstract:
//     'We present high quality image synthesis results using diffusion probabilistic models, a class of latent variable models inspired by considerations from nonequilibrium thermodynamics. Our best results are obtained by training on a weighted variational bound designed according to a novel connection between diffusion probabilistic models and denoising score matching with Langevin dynamics, and our models naturally admit a progressive lossy decompression scheme that can be interpreted as a generalization of autoregressive decoding. On the unconditional CIFAR10 dataset, we obtain an Inception score of 9.46 and a state-of-the-art FID score of 3.17. On 256x256 LSUN, we obtain sample quality similar to ProgressiveGAN.',
//   reviewState: REVIEW_STATES.FIRST_ROUND.name,
//   stateUpdateTime: '2022-03-31T10:21:11.198Z',
//   doubleBlind: true,
//   currentReputationBid: 133,
// };

// const cpuGanPaper = {
//   arxivID: '1917.3212v2',
//   title: 'CPUs are all you need for GANs',
//   submitDate: '2020-01-07T23:21:11.198Z',
//   authors: ['Et Al'],
//   subjects: [SUBJECT_OPTIONS.GANS],
//   field: ['Image Generation', 'Image Editing'],
//   reviewState: REVIEW_STATES.PRE_REVIEW.name,
//   doubleBlind: true,
//   currentReputationBid: 133,
//   abstract:
//     'In recent years it has been shown that GPUs are not enough to train GANs. In this paper, we propose a new architecture for GAN training that uses CPUs instead of GPUs. We show that this architecture can be used to train GANs on a variety of datasets, including CIFAR-10, CelebA, and LSUN. The architecture is designed to be flexible enough to be used with any dataset, and to be able to train GANs on a variety of datasets. ',
// };

// const RonPaper = {
//   title: 'RON: Mask Removal from Facial Images',
//   doubleBlind: true,
//   abstract:
//     'We present RON, a method for removing masks from facial images. RON is a novel method for removing masks from facial images. The method is based on the idea that masks are composed of multiple components, such as eyes, nose, and mouth. RON removes the components of the mask that are not present in the image. The method is based on the idea that masks are composed of multiple components, such as eyes, nose, and mouth. RON removes the components of the mask that are not present in the image.',
// };

// const allscale = {
//   arxivID: '1907.12122v1',
//   title: "It's All About The Scale - Efficient Text Detection Using Adaptive Scaling",
//   paperLink: 'https://arxiv.org/abs/1907.12122',
//   codeLink: 'https://github.com/eladrich/pixel2style2pixel',
//   pageLink: 'https://eladrich.github.io/pixel2style2pixel/',
//   figureLink: 'https://d3i71xaburhd42.cloudfront.net/fdd6e9a558d09d406bb7070b3e4ffc8ff024cd3f/1-Figure1-1.png',
//   submitDate: '2019-07-28T23:21:11.198Z',
//   authors: ['Elad Richardson', 'Yaniv Azar', 'Or Avioz'],
//   subjects: [SUBJECT_OPTIONS.DOCUMENT],
//   field: ['Text Detection'],
//   abstract:
//     '"Text can appear anywhere". This property requires us to carefully process all the pixels in an image in order to accurately localize all text instances. In particular, for the more difficult task of localizing small text regions, many methods use an enlarged image or even several rescaled ones as their input. This significantly increases the processing time of the entire image and needlessly enlarges background regions. If we were to have a prior telling us the coarse location of text instances in the image and their approximate scale, we could have adaptively chosen which regions to process and how to rescale them, thus significantly reducing the processing time. To estimate this prior we propose a segmentation-based network with an additional "scale predictor", an output channel that predicts the scale of each text segment. The network is applied on a scaled down image to efficiently approximate the desired prior, without processing all the pixels of the original image. The approximated prior is then used to create a compact image containing only text regions, resized to a canonical scale, which is fed again to the segmentation network for fine-grained detection. We show that our approach offers a powerful alternative to fixed scaling schemes, achieving an equivalent accuracy to larger input scales while processing far fewer pixels. Qualitative and quantitative results are presented on the ICDAR15 and ICDAR17 MLT benchmarks to validate our approach.',
//   reviewData: [{ novelty: 3, validation: 2, significance: 2, presentation: 2, reproducibility: 3 }],
//   reviewState: REVIEW_STATES.PRE_REVIEW.name,
//   currentReputationBid: 152,
// };

// const ganviolence = {
//   arxivID: '1703.02528v1',
//   title: 'Stopping GAN Violence: Generative Unadversarial Networks',
//   paperLink: 'https://arxiv.org/abs/1703.02528',
//   codeLink: 'https://github.com/eladrich/pixel2style2pixel',
//   pageLink: 'https://eladrich.github.io/pixel2style2pixel/',
//   figureLink: 'https://d3i71xaburhd42.cloudfront.net/fdd6e9a558d09d406bb7070b3e4ffc8ff024cd3f/1-Figure1-1.png',
//   submitDate: '2021-07-28T23:21:11.198Z',
//   authors: ['Elad Richardson', 'Yaniv Azar', 'Or Avioz'],
//   subjects: [SUBJECT_OPTIONS.GANS],
//   abstract:
//     '"While the costs of human violence have attracted a great deal of attention from the research community, the effects of the network-on-network (NoN) violence popularised by Generative Adversarial Networks have yet to be addressed. In this work, we quantify the financial, social, spiritual, cultural, grammatical and dermatological impact of this aggression and address the issue by proposing a more peaceful approach which we term Generative Unadversarial Networks (GUNs). Under this framework, we simultaneously train two models: a generator G that does its best to capture whichever data distribution it feels it can manage, and a motivator M that helps G to achieve its dream. Fighting is strictly verboten and both models evolve by learning to respect their differences. The framework is both theoretically and electrically grounded in game theory, and can be viewed as a winner-shares-all two-player game in which both players work as a team to achieve the best score. Experiments show that by working in harmony, the proposed model is able to claim both the moral and log-likelihood high ground. Our work builds on a rich history of carefully argued position-papers, published as anonymous YouTube comments, which prove that the optimal solution to NoN violence is more GUNs.',
//   reviewData: [{ novelty: 3, validation: 2, significance: 2, presentation: 2, reproducibility: 3 }],
//   reviewState: REVIEW_STATES.PRE_REVIEW.name,
//   currentReputationBid: 152,
// };

// export const restyle = {
//   arxivID: '2104.02699',
//   title: 'ReStyle: A Residual-Based StyleGAN Encoder via Iterative Refinement',
//   submitDate: '2021-05-07T23:21:11.198Z',
//   reviewDate: '2021-07-17T23:21:11.198Z',
//   figureLink: 'https://d3i71xaburhd42.cloudfront.net/64ea8f180d0682e6c18d1eb688afdb2027c02794/1-Figure1-1.png',
//   authors: ['Ano Nymus'],
//   subjects: [SUBJECT_OPTIONS.GANS],
//   abstract:
//     'Recently, the power of unconditional image synthesis has significantly advanced through the use of Generative Adversarial Networks (GANs). The task of inverting an image into its corresponding latent code of the trained GAN is of utmost importance as it allows for the manipulation of real images, leveraging the rich semantics learned by the network. Recognizing the limitations of current inversion approaches, in this work we present a novel inversion scheme that extends current encoder-based inversion methods by introducing an iterative refinement mechanism. Instead of directly predicting the latent code of a given real image using a single pass, the encoder is tasked with predicting a residual with respect to the current estimate of the inverted latent code in a self-correcting manner. Our residual-based encoder, named ReStyle, attains improved accuracy compared to current state-of-the-art encoder-based methods with a negligible increase in inference time. We analyze the behavior of ReStyle to gain valuable insights into its iterative nature. We then evaluate the performance of our residual encoder and analyze its robustness compared to optimization-based inversion and state-of-the-art encoders. ',
//   reviewState: REVIEW_STATES.AUTHOR_RESPONSE.name,
//   stateUpdateTime: '2023-07-17T23:21:11.198Z',
//   doubleBlind: false,
//   hasCode: true,
//   mockBadges: [{ icon: 'ant-design:trophy-outline', label: 'Top %1 2018' }],
//   reviews: [
//     {
//       remarks: {
//         paperBrief: 'It has words ',
//         updateSummary: 'I realized paper is more novel than I originally thought',
//       },
//       novelty: { text: 'Bla Bla No Novel!', initialScore: 4, finalScore: 4 },
//       validation: { text: 'Much Validation!', initialScore: 2, finalScore: 3 },
//       significance: { text: 'No Significant!', initialScore: 2, finalScore: 2 },
//       presentation: { text: 'WOW! Much Pres!', initialScore: 4, finalScore: 5 },
//       reproducibility: { text: 'Just did!', initialScore: 1, finalScore: 1 },
//     },
//     {
//       remarks: {
//         paperBrief: 'It has words ',
//         updateSummary: 'I realized paper is more novel than I originally thought',
//       },
//       novelty: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
//       validation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
//       significance: { text: 'Bla Bla', initialScore: 2, finalScore: 2 },
//       presentation: { text: 'Bla Bla', initialScore: 4, finalScore: 4 },
//       reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
//     },
//     {
//       remarks: {
//         paperBrief: 'It has words ',
//         updateSummary: 'I realized paper is more novel than I originally thought',
//       },
//       novelty: { text: 'Bla Bla', initialScore: 4, finalScore: 5 },
//       validation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
//       significance: { text: 'Bla Bla', initialScore: 1, finalScore: 2 },
//       presentation: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
//       reproducibility: { text: 'Bla Bla', initialScore: 2, finalScore: 1 },
//     },
//     {
//       remarks: {
//         paperBrief: 'It has words ',
//         updateSummary: 'I realized paper is more novel than I originally thought',
//       },
//       novelty: { text: 'Bla Bla', initialScore: 5, finalScore: 4 },
//       validation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
//       significance: { text: 'Bla Bla', initialScore: 2, finalScore: 3 },
//       presentation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
//       reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 2 },
//     },
//     {
//       remarks: {
//         paperBrief: 'It has words ',
//         updateSummary: 'I realized paper is more novel than I originally thought',
//       },
//       novelty: { text: 'Bla Bla', initialScore: 3, finalScore: 5 },
//       validation: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
//       significance: { text: 'Bla Bla', initialScore: 3, finalScore: 5 },
//       presentation: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
//       reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 5 },
//     },
//   ],
//   discussion: [
//     { reviewer: 1, time: '2022-03-17T23:21:11.198Z', text: 'I think we should consider' },
//     { reviewer: 3, time: '2022-03-17T23:24:11.198Z', text: 'Agreed!' },
//   ],
//   authorResponse: 'We thank the reviewers for their feedback and hope that they will help us improve the paper.',
//   // TODO: Think it review should be a subdictionary, could make sense but dont want to overcomplicate the code,
// };

// export const tyga = {
//   arxivID: '2105.02700',
//   title: 'TYGA: Transform Your GAN',
//   submitDate: '2021-01-07T23:21:11.198Z',
//   reviewDate: '2021-06-11T23:21:11.198Z',
//   figureLink: 'https://d3i71xaburhd42.cloudfront.net/64ea8f180d0682e6c18d1eb688afdb2027c02794/1-Figure1-1.png',
//   authors: ['Ano Nymus'],
//   subjects: [SUBJECT_OPTIONS.GANS],
//   abstract: 'We like transforming GANs',
//   reviewState: REVIEW_STATES.POST_REVIEW.name,
//   stateUpdateTime: '2023-07-17T23:21:11.198Z',
//   doubleBlind: false,
//   hasCode: true,
//   mockBadges: [{ icon: 'ant-design:trophy-outline', label: 'Top %1 2018' }],
//   reviews: [
//     {
//       remarks: {
//         paperBrief: 'It has words ',
//         updateSummary: 'I realized paper is more novel than I originally thought',
//       },
//       novelty: { text: 'Bla Bla No Novel!', initialScore: 3, finalScore: 3 },
//       validation: { text: 'Much Validation!', initialScore: 4, finalScore: 3 },
//       significance: { text: 'No Significant!', initialScore: 2, finalScore: 2 },
//       presentation: { text: 'WOW! Much Pres!', initialScore: 4, finalScore: 5 },
//       reproducibility: { text: 'Just did!', initialScore: 1, finalScore: 1 },
//     },
//     {
//       remarks: {
//         paperBrief: 'It has words ',
//         updateSummary: 'I realized paper is more novel than I originally thought',
//       },
//       novelty: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
//       validation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
//       significance: { text: 'Bla Bla', initialScore: 2, finalScore: 2 },
//       presentation: { text: 'Bla Bla', initialScore: 4, finalScore: 4 },
//       reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
//     },
//     {
//       remarks: {
//         paperBrief: 'It has words ',
//         updateSummary: 'I realized paper is more novel than I originally thought',
//       },
//       novelty: { text: 'Bla Bla', initialScore: 4, finalScore: 5 },
//       validation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
//       significance: { text: 'Bla Bla', initialScore: 1, finalScore: 2 },
//       presentation: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
//       reproducibility: { text: 'Bla Bla', initialScore: 2, finalScore: 1 },
//     },
//     {
//       remarks: {
//         paperBrief: 'It has words ',
//         updateSummary: 'I realized paper is more novel than I originally thought',
//       },
//       novelty: { text: 'Bla Bla', initialScore: 5, finalScore: 4 },
//       validation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
//       significance: { text: 'Bla Bla', initialScore: 2, finalScore: 3 },
//       presentation: { text: 'Bla Bla', initialScore: 3, finalScore: 3 },
//       reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 2 },
//     },
//     {
//       remarks: {
//         paperBrief: 'It has words ',
//         updateSummary: 'I realized paper is more novel than I originally thought',
//       },
//       novelty: { text: 'Bla Bla', initialScore: 3, finalScore: 5 },
//       validation: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
//       significance: { text: 'Bla Bla', initialScore: 3, finalScore: 5 },
//       presentation: { text: 'Bla Bla', initialScore: 3, finalScore: 4 },
//       reproducibility: { text: 'Bla Bla', initialScore: 3, finalScore: 5 },
//     },
//   ],
//   discussion: [
//     { reviewer: 1, time: '2022-03-17T23:21:11.198Z', text: 'I think we should consider' },
//     { reviewer: 3, time: '2022-03-17T23:24:11.198Z', text: 'Agreed!' },
//   ],
//   authorResponse: 'We thank the reviewers for gazing into the future with us!',
//   // TODO: Think it review should be a subdictionary, could make sense but dont want to overcomplicate the code,
// };

export const papers = [
  fastest,
  leshrod,
  MRI,
  blocks,
  dolphin,
  oneshot,
  shallow,
  details,
  nerfoundation,
  connecting,
  kfir,
  yuval,
  nofar,
  elad,
  // paper2,
  // restyle,
  // allscale,
  // diffusion,
  // ganviolence,
  // cpuGanPaper,
];

// , diffusion, allscale
